import tw from "twin.macro"

const HiTitle = tw.h3`
 text-brand-black py-1 px-2 bg-brand-blue
 table font-display font-black
`

export default HiTitle
